import { IconRender, InheritProps } from '../IconRender';

export function SliderIcon(props: InheritProps) {
  return (
    <IconRender
      {...props}
      childrenRender={(color: string) => (
        <>
          <rect x="2" y="2" width="76" height="76" rx="11" fill="#343434" stroke={color} strokeWidth="3" />
          <rect x="18" y="48" width="44" height="22" rx="5" fill="#D9D9D9" />
          <path
            d="M68 52.5C68.4 52.5 68.7 52.7 69 52.9L73.5 58.3C73.7 58.5 73.8 58.9 73.8 59.2C73.8 59.5 73.7 59.8 73.5 60L69 65.4C68.7 65.7 68.4 65.8 68 65.8C67.7 65.8 67.4 65.6 67.2 65.4C67 65.1 66.9 64.8 66.9 64.5C66.8 64.1 66.9 63.8 67.2 63.5L71 59.2L67.2 54.7C67 54.4 66.8 54.1 66.8 53.8C66.8 53.4 66.9 53.1 67.2 52.9C67.4 52.7 67.7 52.5 68 52.5Z"
            fill="#D9D9D9"
            stroke="#D9D9D9"
            strokeWidth="0.8"
          />
          <path
            d="M12 66C11.6 66 11.3 65.8 11 65.6L6.5 60.2C6.3 59.9 6.2 59.6 6.2 59.3C6.2 59 6.3 58.7 6.5 58.5L11 53C11.3 52.7 11.6 52.5 12 52.5C12.3 52.5 12.6 52.7 12.8 53C13 53.3 13.1 53.6 13.2 53.9C13.2 54.3 13.1 54.6 12.8 54.9L9 59.3L12.8 63.7C13 64 13.2 64.3 13.2 64.6C13.2 65 13 65.3 12.8 65.6C12.6 65.8 12.3 66 12 66Z"
            fill="#D9D9D9"
            stroke="#D9D9D9"
            strokeWidth="0.8"
          />
          <rect x="38" y="54" width="19" height="3" rx="1.5" fill="#343434" />
          <rect x="38" y="59" width="11" height="3" rx="1.5" fill="#343434" />
          <rect x="22" y="53" width="13" height="13" rx="2" fill="#343434" />
        </>
      )}
    />
  );
}
